<template>
  <section>
    <div class="columns">
      <div class="column is-narrow">
        <h2 class="subtitle has-text-weight-bold has-text-primary is-size-4">
          Produtos ({{ fields.products.length }})
        </h2>
      </div>
      <div class="buttons has-addons">
        <sc-button
          theme="primary"
          @click="addProduct"
          text="Adicionar produto"/>
        <sc-button
          :disabled="fields.products.length === 1"
          theme="default"
          @click="cleanProducts(fields.products.length)"
          text="Limpar produtos"/>
      </div>
    </div>
    <div class="sc-product_scroll">
      <div class="columns is-multiline">
        <div
          v-for="(product, productKey) in fields.products"
          :key="productKey"
          class="column is-4">
          <sc-card
            ref="cardTest">
            <template slot="header">
              <div class="columns">
                <div class="column">
                  <h2 class="has-text-primary is-size-10 card-header-title">
                    Produto {{ productKey + 1 }}
                  </h2>
                </div>
                <div
                  class="sc-product_header column is-6 has-addons">
                  <sc-field>
                    <sc-button
                      :disabled="productKey === 0"
                      theme="danger"
                      size="small"
                      @click="deletProduct(productKey)"
                      text="Deletar"/>

                    <sc-button
                      theme="info"
                      size="small"
                      @click="replicateProduct(product)"
                      text="Replicar"/>
                    <sc-field
                      :prop="`products.${productKey}.replicateQtd`">
                      <sc-input
                        type="number"
                        min="1"
                        size="is-small"
                        v-model="product.replicateQtd" />
                    </sc-field>
                  </sc-field>
                </div>
              </div>
            </template>

            <template slot="body">
              <div
                class="columns">
                <div
                  class="column is-6">
                  <sc-field
                    label="Produto agrupável ?"
                    :prop="`products.${productKey}.replicateQtd`">
                    <sc-switch
                      v-model="product.can_group" />
                  </sc-field>
                  <sc-field
                    label="Quantidade"
                    :prop="`products.${productKey}.quantity`">
                    <sc-input
                      type="number"
                      min="1"
                      placeholder="Digite quantidade de produtos"
                      v-model="product.quantity"
                    />
                  </sc-field>
                  <sc-field
                    label="Descriçāo"
                    :prop="`products.${productKey}.description`">
                    <sc-input
                      placeholder="Digite a descrição do produto"
                      v-model="product.description"
                    />
                  </sc-field>
                  <sc-field
                    label="Altura"
                    :prop="`products.${productKey}.height`">
                    <sc-decimal
                      v-model="product.height"
                      :suffix="dimensionUnit()"
                      :precision="2"/>
                  </sc-field>
                  <sc-field
                    label="Peso"
                    :prop="`products.${productKey}.weight`">
                    <sc-decimal
                      v-model="product.weight"
                      :suffix="weightUnit()"
                      :precision="2"/>
                  </sc-field>
                </div>
                <div class="column is-5">
                  <sc-field
                    label="Sku"
                    :prop="`products.${productKey}.sku_id`">
                    <sc-input
                      placeholder="Digite o sku do produto"
                      v-model="product.sku_id"
                    />
                  </sc-field>
                  <sc-field
                    label="Comprimento"
                    :prop="`products.${productKey}.length`">
                    <sc-decimal
                      v-model="product.length"
                      :suffix="dimensionUnit()"
                      :precision="2"/>
                  </sc-field>
                  <sc-field
                    label="Largura"
                    :prop="`products.${productKey}.width`">
                    <sc-decimal
                      v-model="product.width"
                      :suffix="dimensionUnit()"
                      :precision="2"/>
                  </sc-field>
                  <sc-field
                    label="Valor Nota Fiscal"
                    :prop="`products.${productKey}.cost_of_goods`">
                    <sc-input-currency
                      v-model="product.cost_of_goods"/>
                  </sc-field>
                </div>
              </div>
            </template>
          </sc-card>
        </div>
      </div>
    </div>

  </section>

</template>

<script>
import {
  ScField,
  ScDecimal,
  ScDialog,
  ScInput,
  ScInputCurrency,
  ScCard,
  ScSelect,
  ScButton,
  ScSwitch,
  ScCheckbox,
} from '@intelipost-js/secure-components';
import { Storage } from '@intelipost-js/secure-providers';
import EnumDimensions from '../../enums/EnumDimensions';

export default {
  name: 'sc-product',
  props: {
    fields: Object,
  },
  methods: {
    addProduct() {
      this.fields.products.push({
        quantity: 1,
        sku_id: '',
        description: '',
        weight: '',
        height: '',
        width: '',
        length: '',
        cost_of_goods: '',
        replicateQtd: 1,
        can_group: false,
      });
    },
    cleanProducts(productsLength) {
      ScDialog.confirm({
        title: 'Limpar produtos',
        confirmText: 'Limpar',
        message: 'Tem certeza que deseja limpar os produtos?',
        type: 'is-primary',
        hasIcon: false,
        icon: 'times-circle',
        onConfirm: () => {
          this.fields.products.splice(1, productsLength - 1);
        },
      });
    },
    replicateProduct(product) {
      const { replicateQtd = 1 } = product || {};
      for (let i = 0; i < replicateQtd; i += 1) {
        this.fields.products.push(Object.assign({}, product, { replicateQtd: 1 }));
      }
    },
    deletProduct(key) {
      this.fields.products.splice(key, 1);
    },
    weightUnit() {
      const {
        weight_unit,
      } = Storage.get('client') || {};
      return EnumDimensions[weight_unit] ? EnumDimensions[weight_unit].value : '';
    },
    dimensionUnit() {
      const {
        dimension_unit,
      } = Storage.get('client') || {};
      return EnumDimensions[dimension_unit] ? EnumDimensions[dimension_unit].value : '';
    },
  },
  components: {
    ScDecimal,
    ScInputCurrency,
    ScField,
    ScInput,
    ScCard,
    ScSelect,
    ScButton,
    ScSwitch,
    ScCheckbox,
  },
};
</script>
<style lang="scss" scoped>
  .sc-product_header {
    margin-top: 10px,
  }
  .sc-product-switch_text {
    margin-top: 13px,
  }
  .sc-product_scroll{
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 500px;
    padding: 1rem,
  }
</style>





// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-product/ScProduct.vue?54d28448